/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { ContactCreate } from "../../models/contact-create";
import { ContactDetails } from "../../models/contact-details";
import { Status } from "../../models/status";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface CreateContact$Params {
  organisation_id: string;
  check?: boolean;
  body: ContactCreate;
}

export function createContact(
  http: HttpClient,
  rootUrl: string,
  params: CreateContact$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ContactDetails | Status>> {
  const rb = new RequestBuilder(rootUrl, createContact.PATH, "post");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.query("check", params.check, {});
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactDetails | Status>;
    }),
  );
}

createContact.PATH = "/surfdomeinen/organisations/{organisation_id}/contacts/";
